var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButterfly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.607 10.5187C10.3326 15.762 5.92278 19.939 0.5 20V0C5.92278 0.0610466 10.3326 4.23793 10.607 9.48129C10.8776 4.30705 15.1756 0.171359 20.5 0.00457462V19.9955C15.1756 19.8287 10.8776 15.693 10.607 10.5187Z",
    fill: "#AE99FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButterfly);
export default __webpack_public_path__ + "static/media/butterfly.70d884bb6ed8d9cfa53d914f9381105a.svg";
export { ForwardRef as ReactComponent };